// frontend/src/components/cages/CageFormPanel.js
// The add/edit-cage slide-out panel.
//
// Rendered through createPortal to document.body by the parent so it escapes
// the swipe-content-wrapper stacking context — the portal stays in
// CageManagement; this is the panel's contents.
//
// Presentation only: all state and handlers live in CageManagement. `error` is
// field validation and renders here rather than on the page behind the panel,
// where it used to be painted and could not be read.
//
// `editingId` is either null (add), an id (edit one) or an array of ids
// (bulk edit), which is why several fields read "Multiple Values".

import React from 'react';

function CageFormPanel({ editingId, formData, onChange, onSubmit, isSubmitting, onCancel, error }) {
  const isBulkEdit = Array.isArray(editingId);

  const title = editingId
    ? isBulkEdit
      ? `Edit ${editingId.length} Cages`
      : 'Edit Cage'
    : 'Add New Cage';

  const submitLabel = editingId
    ? `Update ${isBulkEdit ? editingId.length : '1'} Cage(s)`
    : 'Add Cage';

  return (
    <div className="add-mouse-section">
      <h2>{title}</h2>
      <form onSubmit={onSubmit} className="add-mouse-form">
        <div className="form-group">
          <label>Display Cage Number *</label>
          <input
            type="text"
            name="display_cage_number"
            value={formData.display_cage_number}
            onChange={onChange}
            placeholder="e.g., C001"
            required
            disabled={isBulkEdit}
          />
        </div>

        <div className="form-group">
          <label>Location</label>
          <input
            type="text"
            name="location"
            value={formData.location}
            onChange={onChange}
            placeholder={isBulkEdit && !formData.location ? 'Multiple Values' : 'e.g., Room A-1'}
          />
        </div>

        <div className="form-group">
          <label>Capacity</label>
          <input
            type="number"
            name="capacity"
            value={formData.capacity}
            onChange={onChange}
            min="1"
            max="20"
            required
          />
        </div>

        <div className="form-group">
          <label>Notes</label>
          <textarea
            type="text"
            name="notes"
            value={formData.notes}
            onChange={onChange}
            placeholder={isBulkEdit && !formData.notes ? 'Multiple Values' : 'Any notes about this cage'}
          />
        </div>

        {/* Breeding status is an explicit override, so it is only offered when editing */}
        {editingId && (
          <div className="form-group">
            <label>Breeding Status (Override)</label>
            <select name="breeding_status" value={formData.breeding_status} onChange={onChange}>
              <option value="Stock">Stock</option>
              <option value="Breeding">Breeding</option>
            </select>
            <small>Manually set the cage's purpose.</small>
          </div>
        )}

        {error && <div className="error">{error}</div>}

        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Saving...' : submitLabel}
        </button>
        <button type="button" onClick={onCancel} className="secondary-button" style={{ marginTop: '10px' }}>
          Cancel
        </button>
      </form>
    </div>
  );
}

export default CageFormPanel;
